// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2xG2a","header":"PatientQuestionnaire_header__14dQd","info":"PatientQuestionnaire_info__20p6v"};